import { render, staticRenderFns } from "./SecondaryGroupSelection.vue?vue&type=template&id=9195c4f0"
import script from "./SecondaryGroupSelection.vue?vue&type=script&lang=js"
export * from "./SecondaryGroupSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports